import type { WorldSnapshot, WorldTerm } from "./world";

const FALLBACK_TERM_COUNT = 4_096;
export const FALLBACK_TICK_MS = 250;
export const FALLBACK_PRECOMPUTE_AHEAD = 300;

export function createFallbackTerms(count = FALLBACK_TERM_COUNT): WorldTerm[] {
  const seen = new Set<number>([0]);
  const terms: WorldTerm[] = [
    { n: "0", previous: "0", value: "0", step: "0", operation: "add" },
  ];
  let current = 0;

  for (let n = 1; n < count; n += 1) {
    const previous = current;
    const subtract = current - n;
    const canSubtract = subtract >= 0 && !seen.has(subtract);
    current = canSubtract ? subtract : current + n;
    seen.add(current);
    terms.push({
      n: String(n),
      previous: String(previous),
      value: String(current),
      step: String(n),
      operation: canSubtract ? "subtract" : "add",
    });
  }
  return terms;
}

export function createFallbackSnapshot(
  terms: readonly WorldTerm[],
  now = Date.now(),
): WorldSnapshot {
  const generatedThrough = terms.at(-1);
  const currentPosition = Math.max(
    0,
    terms.length - 1 - FALLBACK_PRECOMPUTE_AHEAD,
  );
  const current = terms[currentPosition] ?? {
    n: "0",
    previous: "0",
    value: "0",
    step: "0",
    operation: "add" as const,
  };
  return {
    worldId: "0001",
    serverTimeMs: now,
    startedAtMs: now - Number(current.n) * FALLBACK_TICK_MS,
    tickMs: FALLBACK_TICK_MS,
    currentN: current.n,
    current,
    generatedThrough: generatedThrough?.n ?? current.n,
    catchingUp: false,
    nextTickAtMs: now + FALLBACK_TICK_MS,
  };
}
